export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS'
export const GET_CAMPAIGNS_FAILURE = 'GET_CAMPAIGNS_FAILURE';
export const CLEAN_CAMPAIGNS = 'CLEAN_CAMPAIGNS';
export const CAMPAIGNS_INIT_STATE = null;